import { CoupleSettings, DailyLetter, MemoryItem, SpecialEvent, SongTrack } from '../types';

export const DEFAULT_PLAYLIST: SongTrack[] = [];

export const DEFAULT_SETTINGS: CoupleSettings = {
  partner1Name: '',
  partner2Name: '',
  partner1BirthDate: '',
  partner2BirthDate: '',
  partner1BloodType: 'O+',
  partner2BloodType: 'O+',
  partner1Title: '',
  partner2Title: '',
  partner1Avatar: '',
  partner2Avatar: '',
  partner1Email: 'jacksonceron520@gmail.com',
  partner2Email: '',
  startDate: '',
  quote: '',
  location: '',
  theme: 'sky-garden',
  musicEnabled: true,
  playlist: [],
  activeSongId: '',
  musicVolume: 0.7,
  musicAutoplay: false,
  musicLoopMode: 'all',
  atmosphereMode: 'auto',
  manualTimeOfDay: 'day',
  manualWeather: 'sunny',
  tulipSettings: {
    mode: 'individual',
    allColor: 'golden',
    individualColors: ['golden', 'peach', 'pink', 'ruby'],
  },
  gardenWatering: {
    lastWateredAt: new Date().toISOString(),
    wateredCount: 1,
    lastWateredBy: 'Jardín',
    wateringIntervalDays: 3,
    canWaterLevel: 100,
    lastWaterRefillDate: new Date().toISOString().split('T')[0],
    flowerWateredAt: [
      new Date().toISOString(),
      new Date().toISOString(),
      new Date().toISOString(),
      new Date().toISOString(),
    ],
  },
  navVisibility: {
    garden: true,
    blog: true,
    letters: true,
    animations: true,
    myWeb: true,
    myweb: true,
  },
  myWebConfig: {
    autoApproval: false, // Por defecto manual; configurable desde el panel admin
    whatsappAdminNumber: '', // Número de WhatsApp configurado por el administrador desde el panel
    whatsappMessageTemplate: '¡Hola! Mi solicitud #{code} para adquirir una web de pareja con {partner} ha sido aprobada. Quisiera coordinar los detalles.',
    enabled: true,
  },
  appDownloadLinks: [],
  totalAppDownloads: 0,
  appKillSwitch: {
    isEnabled: false,
    title: 'Actualización Obligatoria Requerida',
    message: 'Hemos lanzado una nueva versión con mejoras de rendimiento, optimizaciones de seguridad y nuevas funciones exclusivas. Por favor actualiza la app para continuar disfrutando de nuestros recuerdos.',
    minVersion: '2.0.0',
    currentVersion: '2.0.0',
    updateButtonText: 'Actualizar App Ahora',
    updateActionType: 'auto',
    allowAdminBypass: true,
  },
  webMaintenance: {
    isEnabled: false,
    title: 'Sitio Web en Mantenimiento',
    message: 'Estamos realizando mejoras, renovando recuerdos y optimizando la experiencia con mucho amor. Volveremos muy pronto.',
    estimatedReturn: '',
    allowAdminBypass: true,
  },
};

// 100% clean memories (empty by default so couple can publish real photos and videos)
export const INITIAL_MEMORIES: MemoryItem[] = [];

// 100% clean daily letters (empty by default so couple can write authentic letters)
export const INITIAL_DAILY_LETTERS: DailyLetter[] = [];

// Compatibility alias
export const INITIAL_SPECIAL_EVENTS: SpecialEvent[] = INITIAL_DAILY_LETTERS;

